import { useMemo } from 'react'

// Alegra ARG - Identification Type Values
export const ALEGRA_ARG_IDENTIFICATION_TYPE_VALUES = [
	{ label: 'CUIT', value: 'CUIT' },
	{ label: 'CDI', value: 'CDI' },
	{ label: 'CI', value: 'CI' },
	{ label: 'PASSPORT', value: 'PASSPORT' },
	{ label: 'DNI', value: 'DNI' },
	{ label: 'OTHER', value: 'OTHER' },
] as const

// Alegra ARG - IVA Condition Values
export const IVA_CONDITION_VALUES = [
	{ label: 'Iva Responsable', value: 'IVA_RESPONSABLE' },
	{
		label: 'Iva Responsable No Inscript',
		value: 'IVA_RESPONSABLE_NO_INSCRIPT',
	},
	{ label: 'Iva Exempt', value: 'IVA_EXEMPT' },
	{ label: 'Final Consumer', value: 'FINAL_CONSUMER' },
	{ label: 'Unique Tribute Responsable', value: 'UNIQUE_TRIBUTE_RESPONSABLE' },
	{ label: 'Provider From Exterior', value: 'PROVIDER_FROM_EXTERIOR' },
	{ label: 'Client From Exterior', value: 'CLIENT_FROM_EXTERIOR' },
	{ label: 'Iva Released Law 19640', value: 'IVA_RELEASED_LAW_19640' },
	{ label: 'Unique Tribute Social', value: 'UNIQUE_TRIBUTE_SOCIAL' },
	{ label: 'Iva Not Reached', value: 'IVA_NOT_REACHED' },
] as const

// Alegra ESP - Identification Type Values
export const ALEGRA_ESP_IDENTIFICATION_TYPE_VALUES = [
	{ label: 'DNI', value: 'DNI' },
	{ label: 'NIF', value: 'NIF' },
	{ label: 'NIF (European)', value: 'NIF-IVA' },
	{ label: 'Passport', value: 'PP' },
	{ label: 'Document of origin country', value: 'DPO' },
] as const

// Alegra COL - Identification Type Values
export const IDENTIFICATION_TYPE_VALUES = [
	{ label: 'Registro civil', value: 'RC' },
	{ label: 'Tarjeta de identidad', value: 'TI' },
	{ label: 'Cédula de ciudadanía', value: 'CC' },
	{ label: 'Tarjeta de extranjería', value: 'TE' },
	{ label: 'Cédula de extranjería', value: 'CE' },
	{ label: 'Número de identificación tributaria', value: 'NIT' },
	{ label: 'Pasaporte', value: 'PP' },
	{ label: 'Permiso especial de permanencia', value: 'PEP' },
	{ label: 'Documento de identificación extranjero', value: 'DIE' },
	{ label: 'NUIP', value: 'NUIP' },
] as const

// Alegra COL - Kind of Person Values
export const KIND_OF_PERSON_VALUES = [
	{ label: 'Persona jurídica', value: 'PERSONA_JURIDICA' },
	{ label: 'Persona natural', value: 'PERSONA_NATURAL' },
] as const

// Alegra COL - Regime Values
export const REGIME_VALUES = [
	{ label: 'Régimen simplificado', value: 'REGIMEN_SIMPLIFICADO' },
	{ label: 'Régimen común', value: 'REGIMEN_COMUN' },
	{ label: 'Gran contribuyente', value: 'GRAN_CONTRIBUYENTE' },
	{ label: 'Autorretenedor', value: 'AUTORRETENEDOR' },
	{ label: 'Régimen simple', value: 'REGIMEN_SIMPLE' },
	{ label: 'No aplica', value: 'NO_APLICA' },
] as const

// Alegra MEX - Regime Values
export const REGIMES_MEX_VALUES = [
	{ label: '601', value: '601' },
	{ label: '603', value: '603' },
	{ label: '605', value: '605' },
	{ label: '606', value: '606' },
	{ label: '607', value: '607' },
	{ label: '608', value: '608' },
	{ label: '609', value: '609' },
	{ label: '610', value: '610' },
	{ label: '611', value: '611' },
	{ label: '612', value: '612' },
	{ label: '614', value: '614' },
	{ label: '615', value: '615' },
	{ label: '616', value: '616' },
	{ label: '620', value: '620' },
	{ label: '621', value: '621' },
	{ label: '622', value: '622' },
	{ label: '623', value: '623' },
	{ label: '624', value: '624' },
	{ label: '625', value: '625' },
	{ label: '626', value: '626' },
] as const

// Hooks to use the constants
export const useAlegraArgIdentificationTypes = () => {
	return useMemo(() => ALEGRA_ARG_IDENTIFICATION_TYPE_VALUES, [])
}

export const useIvaConditionValues = () => {
	return useMemo(() => IVA_CONDITION_VALUES, [])
}

export const useAlegraEspIdentificationTypes = () => {
	return useMemo(() => ALEGRA_ESP_IDENTIFICATION_TYPE_VALUES, [])
}

export const useAlegraColIdentificationTypes = () => {
	return useMemo(() => IDENTIFICATION_TYPE_VALUES, [])
}

export const useKindOfPersonValues = () => {
	return useMemo(() => KIND_OF_PERSON_VALUES, [])
}

export const useRegimeValues = () => {
	return useMemo(() => REGIME_VALUES, [])
}

export const useRegimesMexValues = () => {
	return useMemo(() => REGIMES_MEX_VALUES, [])
}
